
const TRANSLATION = {

}

export const displayText = (KEY) => {

	if(typeof TRANSLATION[KEY] !== 'undefined') {
		return TRANSLATION[KEY];
	} else {
		return KEY;
	}
}